import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Container,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import LocationIcon from "@mui/icons-material/LocationOn";
import { eagle_icon, mentor1, site1 } from "../assets/images";
import { useParams } from "react-router-dom";
import { collection, db } from "../firebaseConfig";
import { doc, getDoc, getDocs } from "firebase/firestore";

const Site = () => {
  const { id } = useParams();
  const [site, setSite] = useState("");
  const [mentors, setMentors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const groupText2 = [
    {
      id: 1,
      title: "Successes",
      text: "“ We are experiencing power cuts that are disrupting our learning group sessions. If this continues, our Form 4 learners will face challenges in being prepared for their national examinations. Also, mentoring children of my generation has not been easy, but I am ready for the challenge! ”",
    },
    {
      id: 2,
      title: "Successes",
      text: "” During the final week of the holiday, we focused on the teachings in Matthew 5:13-16 of Jesus in the Sermon on the Mount. The main lessons were centered on being the light and salt of the earth. The most significant achievement in the learning group is observing the students gradually change, and I am hopeful that the learners will have a positive impact on their peers. “",
    },
  ];

  useEffect(() => {
    const fetchSiteData = async () => {
      try {
        setLoading(true);
        /* Fetch the site data */
        const sitesDocRef = doc(db, "sites", id);
        const siteDoc = await getDoc(sitesDocRef);

        if (siteDoc.exists()) {
          const siteData = siteDoc.data();
          setSite(siteData);
        } else {
          setError("Site not found");
          return;
        }

        /* Fetch the mentor subcollection */
        const mentorSubcollectionRef = collection(sitesDocRef, "mentors");
        const mentorSnapshot = await getDocs(mentorSubcollectionRef);
        if (mentorSnapshot.empty) {
          setError("No mentor found");
          return;
        }

        const mentorList = mentorSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setMentors(mentorList);
        console.log(mentorList);
      } catch (err) {
        console.error("Error fetching site data:", err);
        setError("Error fetching site data.");
      } finally {
        setLoading(false);
      }
    };

    fetchSiteData();
  }, [id]);

  return (
    <>
      {/* Site hero section */}
      <Box
        sx={{
          width: "100vw",
          height: "50vh",
          backgroundColor: "secondary.main",
        }}
      >
        <Container
          sx={{
            height: "inherit",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="h1" color="white">
            {site.siteName}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              my: 2,
            }}
          >
            <LocationIcon sx={{ color: "primary.main" }} />
            <Typography color="primary.dark">{site.siteAddress}</Typography>
          </Box>
          <Typography
            variant="body1"
            sx={{ maxWidth: "70%", textAlign: "center" }}
            color="primary.dark"
          >
            {site.description}
          </Typography>
        </Container>
      </Box>

      {/* Site info card and image */}

      <Box sx={{ width: "100vw" }}>
        <Container
          sx={{ display: "flex", flexDirection: "row", height: "50vh" }}
        >
          <Box
            sx={{
              position: "relative",
              top: 50,
              left: 0,
              width: "60vw",
              height: "80%",
              backgroundColor: "primary.main",
              zIndex: 1,
              backgroundImage: `url(${site1})`,
              backgroundSize: "cover",
              borderRadius: 5,
            }}
          />
          <Box
            sx={{
              position: "relative",
              top: 80,
              right: 20,
              width: "40vw",
              height: "65%",
              backgroundColor: "secondary.main",
              zIndex: 2,
              padding: 2,
            }}
          >
            <Typography
              variant="h7"
              sx={{ textTransform: "uppercase" }}
              color="white"
            >
              Eagle learning site
            </Typography>
            <Typography variant="h2" color="primary.dark" sx={{ my: 2 }}>
              {site.siteName}
            </Typography>
            <Typography variant="body2" color="primary.dark">
              {site.description}
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Mentor and site information */}

      <Box
        sx={{
          width: "100vw",
          height: "60vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {/* Mentor information */}
        <Container
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", width: "45%" }}>
            <Typography variant="h7">Mentor</Typography>
            <img
              src={mentor1}
              width={140}
              height={150}
              alt="mentor 1"
              style={{ borderRadius: 5, margin: "1rem 0 1rem 0" }}
            />
            <Typography variant="h1" sx={{ mb: 2 }}>
              {mentors[0].name} {mentors[0].surname}
            </Typography>
            <Typography variant="body1">{mentors[0].descr}</Typography>
          </Box>
          {/* Successes and Challenges */}
          <Box
            sx={{
              width: "50%",
              height: "100%",
            }}
          >
            {/* Strengths */}
            <Card
              sx={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background:
                  "linear-gradient(to right, #DB5430, rgba(112, 59, 20, 0))",
                padding: "0 5px 0 5px",
                borderRadius: 3,
                my: 1,
                boxShadow: "none",
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#fff",
                  width: 50,
                  height: 50,
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: 100,
                  flexShrink: 0,
                }}
              >
                <CardMedia
                  component="img"
                  src={eagle_icon}
                  sx={{ width: 25, height: 19 }}
                />
              </Box>
              <CardContent>
                <Typography sx={{ fontWeight: "600" }}>Successes</Typography>
                <Typography>{mentors[0].strength}</Typography>
              </CardContent>
            </Card>

            {/* Weaknesses */}
            <Card
              sx={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background:
                  "linear-gradient(to right, #DB5430, rgba(112, 59, 20, 0))",
                padding: "0 5px 0 5px",
                borderRadius: 3,
                my: 1,
                boxShadow: "none",
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#fff",
                  width: 50,
                  height: 50,
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: 100,
                  flexShrink: 0,
                }}
              >
                <CardMedia
                  component="img"
                  src={eagle_icon}
                  sx={{ width: 25, height: 19 }}
                />
              </Box>
              <CardContent>
                <Typography sx={{ fontWeight: "600" }}>Weaknesses</Typography>
                <Typography>{mentors[0].weakness}</Typography>
              </CardContent>
            </Card>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Site;
